/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_InstanceInputs */

const en_entity_instance = /** @type {(inputs: Entity_InstanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instance`)
};

const de_entity_instance = /** @type {(inputs: Entity_InstanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instanz`)
};

/**
* | output |
* | --- |
* | "Instance" |
*
* @param {Entity_InstanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_instance = /** @type {((inputs?: Entity_InstanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_InstanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_instance(inputs)
	return de_entity_instance(inputs)
});